import { Component, OnInit, OnChanges, Input } from "@angular/core";
import { Entity } from "../../features/entity/domain/models/entity.model";
import { AdvisorWithDisplayPhone, AdvisorFacade } from "common";
import { UntilDestroy, untilDestroyed } from "@ngneat/until-destroy";
import { BehaviorSubject, of } from "rxjs";
import { switchMap } from "rxjs/operators";

@UntilDestroy()
@Component({
    selector: "ifm-advisor-widget",
    templateUrl: "./advisor-widget.component.html",
    styleUrls: ["./advisor-widget.component.scss"],
    standalone: false
})
export class AdvisorWidgetComponent implements OnInit, OnChanges {
  @Input() entity: Entity;
  advisorData: AdvisorWithDisplayPhone | null;

  private readonly advisorId$ = new BehaviorSubject<number | undefined>(
    undefined
  );

  constructor(
    private advisorFacade: AdvisorFacade
  ) { }

  ngOnInit(): void {
    this.advisorId$
      .pipe(
        untilDestroyed(this),
        switchMap((id) =>
          id ? this.advisorFacade.getAdvisorWithPhone$(id) : of(null)
        )
      )
      .subscribe((advisor) => {
        this.advisorData = advisor;
      });
  }

  ngOnChanges(): void {
    this.advisorId$.next(this.entity?.advisorId);
  }

  mailLink(email: string): string {
    return `mailto:${email}`;
  }

  calendarLink(): void {
    window.open(
      this.advisorData?.calendarLinkUrl ??
      "https://calendly.com/ideafinancial",
      "_blank"
    );
  }
}
